import { removeOrphans } from "./ops";
import type { SceneDocument } from "./schema";

/**
 * A copy of a document with only some of its pages (in document order), e.g.
 * „Seiten als einzelne Dateien“. Elements of the other pages are dropped;
 * format, guides and print settings stay.
 */
export function extractPages(doc: SceneDocument, indices: readonly number[]): SceneDocument {
  const keep = [...new Set(indices)]
    .filter((index) => Number.isInteger(index) && index >= 0 && index < doc.pages.length)
    .sort((a, b) => a - b);
  if (keep.length === 0) throw new Error("Keine Seite gewählt");
  const copy = JSON.parse(JSON.stringify(doc)) as SceneDocument;
  copy.pages = keep.map((index) => copy.pages[index]!);
  removeOrphans(copy);
  return copy;
}
